import React from "react";
import { useDispatch, useSelector } from "react-redux";
// import { objectToFormData } from "../../utils";
import credit from "../../assets/icons/credit.png";
import debit from "../../assets/icons/debit.png";
import reversal from "../../assets/icons/reversal.svg";
import { amountFormat } from "../../utils";
import Table from "../Common/Table/Table";
import { transactions } from "./../../actions/cards/cards";
import PageHeader from "./../PageHeader";
import { walletText } from "./CardDetails";
import BaseCurrency from "../Common/BaseCurrency";
// import Base from "antd/lib/typography/Base";
const columns = [
  {
    title: "Transaction ID",
    dataIndex: "vendor_transaction_id",
    key: "vendor_transaction_id",
    render: (text, record) => <div className={`render_common_style status_${record?.status}`}>{text}</div>
  },

  {
    title: "CRN",
    dataIndex: "card_reference_number",
    key: "card_reference_number",
  },
  {
    title: "Employee Name",
    dataIndex: "employee_name",
    key: "employee_name",
    width: 250,
  },
  {
    title: "Transaction Date",
    dataIndex: "transaction_date",
    key: "transaction_date",
  },
  {
    title: "Merchant",
    dataIndex: "merchant",
    key: "merchant",
    render: (text) => <div style={{ whiteSpace: "pre" }}>{text}</div>,
  },
  {
    title: "Wallet Name",
    dataIndex: "wallet_name",
    key: "wallet_name",
    render: (text) => <div>{walletText[text]}</div>,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (text, record) => (
      <div>
        <img
          src={record?.transaction_type === "reversal" && record?.data?.txnType === "Reversal Purchase" ? reversal : record?.transaction_type === "credit" ? credit : debit}
          width={10}
          alt="credit"
        />{" "}
        <BaseCurrency /> {amountFormat(text)}
      </div>
    ),
  },
  // {
  //   title: "Wallet",
  //   dataIndex: "title",
  //   key: "title",
  //   render: (text) => <div>Expense</div>,
  // },
  {
    title: "ChannelType",
    dataIndex: "channelType",
    key: "channelType",
    // render: (text) => <div>Verified</div>,
  },
  {
    title: "Transaction Nature",
    dataIndex: "channelType",
    key: "channelType",
    render: (text, record) => <div>{record?.data?.txnType}</div>,

  },
  {
    title: "Type",
    dataIndex: "transaction_type",
    key: "transaction_type",
  },

  {
    title: "Terminal ID",
    dataIndex: "terminalId",
    key: "terminalId",
  },
  // {
  //   title: "Status",
  //   dataIndex: "status",
  //   key: "status",
  //   render: (text) => <div className={`status ${text}`}>{text}</div>,
  // },
];

const CardTransactions = () => {
  // const history = useHistory();
  const [transData, setTransData] = React.useState([]);
  const [filters, setFilters] = React.useState({});
  const [page, setPage] = React.useState(1);


  const transactionsResponse = useSelector(
    (state) => state.cards.transactions || {}
  );
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(transactions({ card_only: true, source: "admin" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (value) => {
    dispatch(transactions({ card_only: true, search_key: value }));
    setFilters({
      ...filters,
      search_key: value,
      source: "admin"
    });
    setPage(1)

  };

  React.useEffect(() => {
    const {
      data: { response: { transactions = [] } = {}, status = false } = {},
    } = transactionsResponse;
    if (status) {
      setTransData(transactions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionsResponse]);

  // const handleRowClick = (evt, record) => {
  //   evt.preventDefault();
  //   if (record) {
  //     history.push({
  //       pathname: `/card-details/${record?.card_id}`,
  //       state: { cardData: { id: record?.card_id } },
  //     });
  //   }
  // };

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Transactions`}
          navigation={{
            Home: "/dashboard/",
            Cards: "/cards/",
            Transactions: "/card-transactions/",
          }}
        />
      </div>
      <Table
        rowKey="id"
        className="tableStyled"
        columns={columns}
        data={transData}
        placeholder={"Search By Transaction ID, Name"}
        pagination={{

          total: transactionsResponse?.data?.total_records || 0,
          current: page,

          onChange: (pagee) => {
            dispatch(
              transactions({ card_only: true, page: pagee, ...filters, source: "admin" })
            );
            setPage(pagee);
          }
        }}
        dotMenu={[
          "employee_name",
          "transaction_date",
          "merchant_name",
          "amount",
        ]}
        handleSort={(key) => {
          dispatch(transactions({ card_only: true, sort_key: key, source: "admin" }));
          setFilters({
            ...filters,
            sort_key: key,
          });
          setPage(1)

        }}
        isTopFilter={true}
        filter={true}
        // handleRowClick={handleRowClick}
        handleSearch={handleSearch}
        scroll={{ x: 1800 }}
      />
    </>
  );
};

export default CardTransactions;
